import { render, staticRenderFns } from "./MedicalForm.vue?vue&type=template&id=db901064&scoped=true&"
import script from "./MedicalForm.vue?vue&type=script&lang=js&"
export * from "./MedicalForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalForm.vue?vue&type=style&index=0&id=db901064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db901064",
  null
  
)

export default component.exports